<template>
  <div id="ecommerce_product">
    <div v-if="state == 'list'">
      <v-container>
        <div
          :class="{
            'ketshop-bg-color':
              selectedBot.useketshop == true &&
              selectedBot.ketshop_api_key &&
              selectedBot.ketshop_api_secret
          }"
        >
          <v-layout wrap>
            <v-flex xs12 sm2 lg2 class="pl-1">
              <img
                v-if="
                  selectedBot.useketshop == true &&
                  selectedBot.ketshop_api_key &&
                  selectedBot.ketshop_api_secret
                "
                src="/static/img/assets/_global/ketshop_logo.svg"
                alt
                style="max-height: 101px; width: 150px"
              />
            </v-flex>
            <v-flex xs12 sm10 class="form-control pa-2 text-xs-center text-sm-right">
              <template
                v-if="
                  selectedBot.pageid == '106855151601601' || selectedBot.pageid == '102052945584054'
                "
              >
                <cooldown :delay="600" cname="sync_kfc_product" @onLoad="sycnKFCProduct">
                  <template #default="{ zloading, onClick, show }">
                    <v-btn
                      v-if="show"
                      outline
                      color="primary"
                      :loading="zloading || loadingProduct"
                      @click="onClick"
                      >SYNC PRODUCT</v-btn
                    >
                  </template>
                  <template #countdown="{ show, delaytime, onCountdownEnd }">
                    <template v-if="show && delaytime !== true && delaytime > 0">
                      <v-btn color="grey" outline>
                        <countdown :time="delaytime * 1000" @end="onCountdownEnd">
                          <template slot-scope="props">
                            <template v-if="props.minutes > 0">
                              {{ props.minutes }}
                              <span class="small">{{ $t('Minutes') }}</span>
                              {{ props.seconds }}
                              <span class="small">{{ $t('Seconds') }}</span>
                            </template>
                            <template v-else>
                              {{ props.seconds }}
                              <span class="small">{{ $t('Seconds') }}</span>
                            </template>
                          </template>
                        </countdown>
                      </v-btn>
                    </template>
                  </template>
                </cooldown>
              </template>
              <template v-if="selectedBot.theme == 'seagull'">
                <v-btn
                  outline
                  color="primary"
                  :loading="loadingProduct"
                  @click="seagullSyncProduct"
                >
                  SYNC PRODUCT</v-btn
                >
              </template>
              <template v-if="loadingProduct">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </template>
              <input
                v-else-if="categorylist && categorylist.length > 0"
                v-model="search"
                type="text"
                class="form-control ma-0"
                style="display: inline-block; max-width: 300px"
                :placeholder="$t('Search')"
                @input="onSearch"
              />
              <template
                v-if="
                  $store.getters.getPackage == 'premium' &&
                  selectedBot.akita_status &&
                  $store.state.exportProduct.includes(selectedBot.pageid)
                "
              >
                <v-btn outline color="grey" @click="exportAkita"> Export Akita </v-btn>
              </template>
              <v-btn
                v-if="selectedBot.zortout_is_active"
                outline
                color="grey"
                @click="importZortout"
              >
                Import Zortout</v-btn
              >
              <template v-if="!['tcp'].includes(selectedBot.theme)">
                <template v-if="!['thailandpostmart'].includes(selectedBot.type)">
                  <transfer-shop style="display: inline-block"></transfer-shop>
                </template>
                <import-shop-scgdistribution
                  v-if="['scgdistribution'].includes(selectedBot.theme)"
                  style="display: inline-block"
                ></import-shop-scgdistribution>
                <template
                  v-if="
                    selectedBot &&
                    $store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid)
                  "
                ></template>
                <import-shop
                  v-else-if="
                    $store.state.iccpage.includes(selectedBot.pageid) ||
                    $store.state.centralPage.includes(selectedBot.pageid) ||
                    ['104716585038207', '362065616073', '107898204895323'].includes(
                      selectedBot.pageid
                    )
                  "
                  style="display: inline-block"
                ></import-shop>
                <import-shop
                  v-else
                  style="display: inline-block"
                  @success="handleSuccessImport"
                ></import-shop>
              </template>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="isPowerbuyPage" class="py-3">
          <multiselect
            v-model="filterBranch"
            placeholder="เลือกสาขา"
            label="branch"
            :options="powerbuyShopOptions"
            :show-labels="false"
            style="max-width: 300px"
            @input="handleChangeBranch"
          ></multiselect>
        </div>

        <h2 class="headline mt-2">{{ $t('Product By') }}</h2>
        <v-btn
          small
          :outline="productBy !== 'zwiz'"
          color="primary"
          class="mr-0"
          @click="selectProductBy('zwiz')"
        >
          Zwiz Shop
        </v-btn>
        <v-btn
          v-if="selectedBot.zortout_is_active"
          small
          :outline="productBy !== 'zortOut'"
          color="primary"
          class="mr-0"
          @click="selectProductBy('zortOut')"
        >
          Zort out
        </v-btn>
        <!--  -->
        <template v-if="loadingCategory">
          <div style="padding: 30px 0">
            <scale-loader :color="$vuetify.theme.primary" height="45px" width="7px"></scale-loader>
          </div>
        </template>
        <template v-else-if="categorylist && categorylist.length == 0">
          <v-layout wrap>
            <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
              <img src="/static/img/assets/ecommerce/category_tags.png" alt style="width: 230px" />
              <h3 class="headline">{{ $t('create your first category') }}</h3>
              <p>{{ $t('Click Add Category to create a category and add products') }}</p>
              <v-btn color="primary" depressed @click="showCategory = true">
                <em class="fa fa-plus middle mr-1" />
                {{ $t('Add new categories') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
        <template v-else>
          <v-layout wrap>
            <v-flex xs5>
              <h3 class="headline mt-2">{{ $t('Category') }}</h3>
            </v-flex>
            <v-flex xs7 text-xs-right>
              <v-btn
                v-if="
                  !(
                    ['thailandpostmart'].includes(selectedBot.type) ||
                    (selectedBot.useketshop == true &&
                      selectedBot.ketshop_api_key &&
                      selectedBot.ketshop_api_secret)
                  )
                "
                small
                fab
                outline
                class="primary--text"
                @click="showCategory = true"
              >
                <em class="fa fa-pencil-alt middle" />
              </v-btn>
            </v-flex>
          </v-layout>
          <div style="overflow-x: auto; white-space: nowrap; padding-bottom: 15px">
            <template v-if="['thailandpostmart'].includes(selectedBot.type)">
              <filter-category-thailandpostmart
                v-model="currentCategory"
                :categories="categorylist"
                :stat="filterBadge"
                :is-append="selectedBot.theme == 'nvbb'"
                @onChangeCategory="onChangeCategory"
              ></filter-category-thailandpostmart>
            </template>
            <template v-else>
              <filter-category
                v-model="currentCategory"
                :categories="categorylist"
                :stat="filterBadge"
                :is-append="selectedBot.theme == 'nvbb'"
                @onChangeCategory="onChangeCategory"
              ></filter-category>
            </template>
          </div>
          <div v-if="$store.state.kfcpage.includes(selectedBot.pageid) && subcategorylist">
            <filter-category
              v-model="currentSubCategory"
              :categories="subcategorylist"
              :stat="filterBadgeSubcategory"
              @onChangeCategory="onChangeSubCategory"
            ></filter-category>
          </div>

          <v-divider class="mb-3"></v-divider>
          <template v-if="currentCategory && currentCategory != null">
            <v-layout warp>
              <v-flex xs12 sm6>
                <h3 class="headline mt-3">{{ $t('Products') }}</h3>
              </v-flex>
              <v-flex xs12 sm6 class="text-xs-right">
                <v-btn
                  v-if="selectedBot.theme == 'scgdistribution' && currentCategory != 'all'"
                  color="grey"
                  :loading="exportscgloading"
                  outline
                  @click="exportProductScgdistribution"
                >
                  <em class="fas fa-file-exposortisTcprt" />
                  &nbsp;
                  {{ $t('export product') }}
                </v-btn>

                <template v-if="!['tcp'].includes(selectedBot.theme)">
                  <template v-if="!['thailandpostmart'].includes(selectedBot.type)">
                    <v-btn outline color="primary" @click="showSortProduct = true">
                      <v-icon class="mr-2">swap_vert</v-icon>
                      {{ $t('sort product') }}
                    </v-btn>
                  </template>

                  <template
                    v-if="['102052945584054', '106855151601601'].includes(selectedBot.pageid)"
                  >
                    <kfc-sort-product
                      v-if="showSortProduct"
                      v-model="showSortProduct"
                      :categories="categorylist"
                      @onChangeProduct="onChangeProduct"
                    ></kfc-sort-product>
                  </template>
                  <template v-else>
                    <sort-product
                      v-if="showSortProduct"
                      v-model="showSortProduct"
                      :powerbuy-filter-branch="filterBranch"
                      @onChangeProduct="onChangeProduct"
                    ></sort-product>
                  </template>
                </template>
              </v-flex>
            </v-layout>

            <template v-if="!loadingProduct">
              <v-layout v-if="categorylist && filterProducts && filterProducts.length > 0" wrap>
                <v-flex xs12 sm1>
                  <v-select
                    v-model="size"
                    :items="pagelimit"
                    solo
                    small
                    class="browser-default mb-2"
                    hide-details
                    @change="onChangeLimit"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm11 class="text-xs-center text-sm-right">
                  <v-pagination
                    v-model="pageNumber"
                    :total-visible="6"
                    :length="pagelength"
                    @input="changePage"
                  ></v-pagination>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex
                  v-if="
                    !['thailandpostmart'].includes(selectedBot.type) &&
                    !(
                      selectedBot.useketshop == true &&
                      selectedBot.ketshop_api_key &&
                      selectedBot.ketshop_api_secret
                    ) &&
                    selectedBot.pageid != '102052945584054' &&
                    selectedBot.pageid != '106855151601601' &&
                    productBy !== 'zortOut'
                  "
                  xs12
                  sm6
                  md4
                  lg3
                  xl2
                  class="pa-1"
                >
                  <v-flex v-if="productBy !== 'zortOut'">
                    <div
                      class="btn-add"
                      style="position: relative; min-height: 360px; cursor: pointer; height: 100%"
                      @click="onAddNewProduct"
                    >
                      <div
                        style="position: absolute; top: 50%; margin-top: -30px; left: 0; right: 0"
                      >
                        <div class="text-xs-center">
                          <h3 class="headline" style="color: #969595">
                            <em class="fa fa-plus" />
                          </h3>
                          <p>{{ $t('Add new product') }}</p>
                        </div>
                      </div>
                      <template
                        v-if="
                          ($store.getters.getPackage != 'premium' || isCoachlab) &&
                          productlist.length >= maxProduct
                        "
                      >
                        <v-premium-plan-popup
                          :show-all="false"
                          margin-top="65"
                          :size="'small'"
                        ></v-premium-plan-popup>
                      </template>
                    </div>
                  </v-flex>
                </v-flex>

                <template v-if="categorylist && filterProducts && filterProducts.length > 0">
                  <template v-for="(product, index) in filterProducts">
                    <v-flex :key="'product_' + product.id" xs12 sm6 md4 lg3 xl2 class="pa-1">
                      <Productkfc
                        v-if="
                          selectedBot.pageid == '102052945584054' ||
                          selectedBot.pageid == '106855151601601'
                        "
                        v-model="filterProducts[index]"
                        :category="categorylist"
                        :select-category="currentCategory"
                        @changeproductstatus="onChangeProductStatus"
                        @productDeleted="onDeleteProduct(index)"
                        @onSelectedProduct="onSelectedProduct(index, product)"
                      ></Productkfc>
                      <ProductThailandpostmart
                        v-else-if="selectedBot.type == 'thailandpostmart'"
                        v-model="filterProducts[index]"
                        :category="categorylist"
                        :select-category="currentCategory"
                        @changeproductstatus="onChangeProductStatus"
                        @productDeleted="onDeleteProduct(index)"
                        @onSelectedProduct="onSelectedProduct(index, product)"
                      ></ProductThailandpostmart>
                      <product
                        v-else
                        v-model="filterProducts[index]"
                        :category="categorylist"
                        :select-category="currentCategory"
                        :product-by="productBy"
                        @changeproductstatus="onChangeProductStatus"
                        @productDeleted="onDeleteProduct(index)"
                        @onSelectedProduct="onSelectedProduct(index, product)"
                      ></product>
                    </v-flex>
                  </template>
                </template>
                <!-- <template v-else> ไม่มีรายการสินค้า </template> -->
              </v-layout>

              <v-layout
                v-if="categorylist && filterProducts && filterProducts.length > 0"
                wrap
                class="mt-3"
              >
                <v-flex xs12 sm1>
                  <v-select
                    v-model="size"
                    :items="pagelimit"
                    solo
                    small
                    class="mb-2"
                    hide-details
                    @change="onChangeLimit"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm11 class="text-xs-center text-sm-right">
                  <v-pagination
                    v-model="pageNumber"
                    :total-visible="6"
                    :length="pagelength"
                    @input="changePage"
                  ></v-pagination>
                </v-flex>
              </v-layout>
            </template>
            <template v-else>
              <div style="padding: 30px 0">
                <scale-loader
                  :color="$vuetify.theme.primary"
                  height="45px"
                  width="7px"
                ></scale-loader>
              </div>
            </template>
            <div class="mb-5 mt-5"></div>
          </template>
          <template v-else>
            <div class="text-xs-center" style="margin: 35px 0">
              <img src="/static/img/assets/ecommerce/category_tags.png" alt style="width: 300px" />
              <h3 class="headline">{{ $t('Select category') }}</h3>
              <v-btn depressed color="primary" @click="showCategory = true">
                {{ $t('Add new categories') }}
              </v-btn>
            </div>
          </template>
        </template>
        <CategoriesKfc
          v-if="selectedBot.pageid == '106855151601601' || selectedBot.pageid == '102052945584054'"
          v-model="categorylist"
          :show="showCategory"
          @close="showCategory = false"
          @onCategoryChange="onCategoryChange"
          @deleteCategory="deleteCategory"
        ></CategoriesKfc>
        <categories
          v-else
          v-model="categorylist"
          :show="showCategory"
          :powerbuy-filter-branch="filterBranch"
          :product-by="productBy"
          @close="showCategory = false"
          @onCategoryChange="onCategoryChange"
          @deleteCategory="deleteCategory"
        ></categories>
      </v-container>
    </div>

    <div v-else-if="state == 'add-product'">
      <template v-if="categorylist && state == 'add-product'">
        <v-container>
          <!-- Lamy Add Product -->
          <template v-if="[...$store.state.lamyPage].includes(selectedBot.pageid)">
            <lamy-modal-add-product
              :select-category="currentCategory"
              :category="categorylist"
              @onAddProduct="addProduct"
              @close="closeModal"
            ></lamy-modal-add-product>
          </template>
          <template v-else>
            <template v-if="selectedBot">
              <modal-add-product
                :select-category="currentCategory"
                :category="categorylist"
                :powerbuy-filter-branch="filterBranch"
                @onAddProduct="addProduct"
                @close="closeModal"
              ></modal-add-product>
            </template>
          </template>
        </v-container>
      </template>
    </div>
    <div v-else-if="state == 'edit-product'">
      <template v-if="categorylist && currentProduct">
        <v-container>
          <ModalEditProductKFC
            v-if="
              selectedBot.pageid == '106855151601601' || selectedBot.pageid == '102052945584054'
            "
            v-model="currentProduct"
            :select-category="currentCategory"
            :category="categorylist"
            @close="closeModal"
            @onSaveProduct="closeEditProduct"
          ></ModalEditProductKFC>

          <modal-edit-product
            v-else
            v-model="currentProduct"
            :select-category="currentCategory"
            :category="categorylist"
            @close="closeModal"
            @onSaveProduct="closeEditProduct"
          ></modal-edit-product>
        </v-container>
      </template>
    </div>

    <!-- KFC Show Sync Product Modal -->
    <v-dialog v-model="isShowSyncProductModal" persistent width="350px">
      <v-card class="pa-4">
        <div class="my-4 text-xs-center" style="font-size: 16px">
          Sync product successfully. <br />Please wait for 10 minutes.
        </div>
        <div class="text-xs-center">
          <v-btn class="primary" @click="isShowSyncProductModal = false">
            <span>{{ $t('OK') }}</span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Cooldown from '@/components/elements/Cooldown'
import ModalHelp from '@/components/elements/ModalHelp'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import Categories from './Categories'
import CategoriesKfc from './CategoriesKfc'
import CategoriesThailandpostmart from './CategoriesThailandpostmart'
import FilterCategory from './FilterCategory'
import FilterCategoryThailandpostmart from './FilterCategoryThailandpostmart'
import ImportShop from './ImportShop.vue'
import ImportShopScgdistribution from './ImportShopScgdistribution.vue'
import KfcSortProduct from './KfcSortProduct.vue'
import ModalAddProduct from './ModalAddProduct'
import ModalEditProduct from './ModalEditProduct'
import ModalEditProductKFC from './ModalEditProductKFC'
import Product from './Product'
import Productkfc from './Productkfc'
import ProductThailandpostmart from './ProductThailandpostmart'
import SelectCategory from './SelectCategory'
import SortProduct from './SortProduct.vue'
import TransferShop from './TransferShop.vue'
import { PAGE } from '@/constants/page.js'

import api from '@/api'
import seagullApi from '@/api/seagull.js'

export default {
  components: {
    Product,
    ProductThailandpostmart,
    CategoriesThailandpostmart,
    ModalAddProduct,
    ImportShop,
    ModalEditProduct,
    Categories,
    SelectCategory,
    ScaleLoader,
    FilterCategory,
    FilterCategoryThailandpostmart,
    ModalHelp,
    TransferShop,
    SortProduct,
    KfcSortProduct,
    ImportShopScgdistribution,
    CategoriesKfc,
    Productkfc,
    ModalEditProductKFC,
    Cooldown,
    Multiselect
  },
  data: function () {
    return {
      productBy: 'zwiz',
      showSortProduct: false,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      pagetmp: 1,
      // pageNumber: 1,

      pageNumber: 1,
      size: 10,
      currentProduct: undefined,
      currentCategory: 'all',
      currentFilter: 'all',
      productlist: [],
      categorylist: ['All'],
      selectedProduct: null,
      showCategory: false,
      showModal: false,

      loadingProduct: true,
      loadingCategory: true,
      exportscgloading: false,
      pagelimit: [10, 25, 50],

      filterBadge: {
        all: 0,
        sales: 0,
        soldout: 0
      },

      filterBadgeSubcategory: {
        all: 0,
        sales: 0,
        soldout: 0
      },

      productCount: 0,

      search: '',
      state: 'list',
      timestamp: moment().format('x'),
      subcategorylist: undefined,
      currentSubCategory: 'all',
      isShowSyncProductModal: false,
      totalAllProducts: 0,
      totalAllProductsSubcategory: 0,
      searchTimeout: null,
      formatProducts: [],
      filterProducts: [],
      filterBranch: null,
      zortoutImport: {
        status: '',
        loading: false,
        interval: null,
        show: false
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      isFacebook: 'isFacebook'
    }),
    maxProduct() {
      return this.isCoachlab ? 20 : 10
    },
    pageCount: function () {
      let l = this.productCount
      let s = this.size
      return Math.ceil(l / s)
    },
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.size)
      } else {
        return 1
      }
    },
    isPowerbuyPage() {
      return this.selectedBot.theme === 'powerbuy'
    },
    powerbuyShopOptions() {
      return this.$store.state.powerbuyBranchList
    },
    isTcpPage() {
      return (
        PAGE.TCP_MAIN_PAGE.includes(this.selectedBot.pageid) ||
        PAGE.TCP_SHOP_SERVICES.includes(this.selectedBot.pageid)
      )
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    },
    showModal: function (newVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    showCategory: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    currentCategory: function (newVal) {
      if (newVal != null) {
        this.formatProducts = this.handleFormatProducts()
      }
    },

    productlist: async function () {
      await this.$nextTick()
      this.formatProducts = this.handleFormatProducts()
    }
  },
  mounted: function () {
    let vm = this
    vm.getCategories(function () {
      if (vm.categorylist && vm.categorylist.length > 0) {
        vm.onChangeCategory(vm.categorylist[0])
      }
      vm.getProducts().then(() => {
        vm.loadingCategory = false
      })
    })
  },

  methods: {
    async seagullSyncProduct() {
      const body = {
        pageid: this.selectedBot.pageid
      }
      try {
        this.loadingProduct = true
        await seagullApi.postSyncProduct({ body })
        this.getProducts()
        this.$swal.fire({
          type: 'success',
          title: this.$t('Success')
        })
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          title: 'เกิดข้อผิดพลาด',
          text: 'กรุณาลองใหม่อีกครั้ง',
          type: 'error'
        })
      } finally {
        this.loadingProduct = false
      }
    },
    onSearch() {
      const vm = this
      clearTimeout(vm.searchTimeout)
      vm.searchTimeout = setTimeout(() => {
        vm.getProducts()
      }, 1000)
    },
    handleFormatProducts() {
      let products = []

      if (this.currentCategory === 'all') {
        products = this.productlist
      } else {
        products = this.productlist.map((val) => {
          if (this.currentCategory === 'sales') {
            if (parseFloat(val.price) !== parseFloat(val.discountprice)) {
              return val
            } else {
              const isDiscount = val.productstock
                ? val.productstock.find(function (stock, sindex) {
                    return parseFloat(stock[3]) > parseFloat(stock[4])
                  })
                : false

              if (isDiscount) {
                return val
              }
            }
          } else if (this.currentCategory === val.categoryid) {
            return val
          }
          if (val.productstock && val.productstock.length <= 0) {
            if (this.currentCategory === 'soldout') {
              return val
            }
          } else {
            const isAlmostSoldOut = val.productstock
              ? val.productstock.find((stock) => {
                  if (stock[2] <= 5) {
                    return this.currentCategory === 'soldout'
                  } else {
                    return false
                  }
                })
              : false
            if (isAlmostSoldOut) {
              return val
            }
          }
          return val
        })
      }
      products = this.handleFilterProducts(products)
      this.filterProducts = [...products]
      return products
    },
    handleFilterProducts(products) {
      this.handleGetBadge(products)
      return products
    },
    handleGetBadge(products) {
      const badges = products.reduce(
        (prev, curr) => {
          if (parseFloat(curr.price) !== parseFloat(curr.discountprice)) {
            prev.sales += 1
          } else {
            const isDiscount = curr.productstock
              ? curr.productstock.find(function (stock) {
                  return parseFloat(stock[3]) > parseFloat(stock[4])
                })
              : false

            if (isDiscount) {
              prev.sales += 1
            }
          }

          if (curr.productstock) {
            if (curr.productstock.length <= 0) {
              prev.soldout += 1
            } else {
              const isAlmostSoldOut = curr.productstock.find((stock) => {
                return stock[2] <= 5
              })
              if (isAlmostSoldOut) {
                prev.soldout += 1
              }
            }
          } else {
            prev.soldout += 1
          }
          return prev
        },
        {
          all: 0,
          sales: 0,
          soldout: 0
        }
      )

      if (this.$store.state.kfcpage.includes(this.selectedBot.pageid)) {
        this.filterBadge = {
          ...badges,
          all: this.totalAllProducts
        }

        this.filterBadgeSubcategory = {
          ...badges,
          all: this.totalAllProductsSubcategory
        }
      } else {
        this.filterBadge = {
          ...badges,
          all: this.totalAllProducts
        }
      }
    },
    async sycnKFCProduct(payload) {
      this.loadingProduct = true
      this.isShowSyncProductModal = true
      // await api.sycnKFCProduct(this.selectedBot.pageid)
      await api.sycnKFCProduct(this.selectedBot.pageid, function (error, response) {
        if (error) reject(error)
      })
      if (payload) payload.callback()
      this.loadingProduct = false
    },
    exportProductScgdistribution() {
      this.exportscgloading = true
      api.scgdistributionExportProducts(
        {
          pageid: this.selectedBot.pageid,
          categoryid: this.currentCategory
        },
        (err, response) => {
          this.exportscgloading = false
          var json = response.data.map((el) => {
            return {
              keyword: el.keyword,
              image: el.image,
              name: el.name,
              sku: el.sku,
              details: el.details,
              unit: el.unit,
              price: el.price,
              discount_price: el.discount_price,
              quantity: el.quantity,
              quantity_limit: el.quantity_limit
            }
          })
          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          var categoryname = this.categorylist.find((el) => el.id == this.currentCategory).name
          XLSX.writeFile(
            wb,
            categoryname + '_' + moment().format('YYYYMMDD') + '_exportedproduct' + '.xlsx'
          )
        }
      )
    },
    exportAkita() {
      var dataWS = null
      var json = this.productlist.map((product) => {
        var photourl = []
        try {
          if (product.photourl != '') photourl = product.photourl.split(';;')
        } catch (error) {}

        var variants = []

        try {
          variants = JSON.parse(product.productstockcategories)
        } catch (error) {}
        if (variants && variants.length == 0) variants = [{ level: 0, name: 'ตัวเลือก' }]

        if (photourl && photourl.length == 0) {
          photourl[0] =
            'https://zwizai.s3.amazonaws.com/ecommerce/1583138880495image-not-found-big-300x169.png'
        }
        return product.productstock.map((stock) => {
          var stock_variants = []
          var price = 0

          if (stock[4]) {
            price = stock[4]
          } else if (stock[3]) {
            price = stock[3]
          } else if (product.discountprice) {
            price = product.discountprice
          } else {
            price = product.price
          }
          try {
            stock_variants = stock[1].split('/')
          } catch (error) {}
          return {
            code: product.code,
            name: product.name,
            description: product.description,
            variant1: variants[0].name,
            variant2: variants && variants.length > 1 ? variants[1].name : '',
            brand: '',
            photo1: photourl[0],
            photo2: photourl[1] ? photourl[1] : '',
            photo3: photourl[2] ? photourl[2] : '',
            photo4: photourl[3] ? photourl[3] : '',
            photo5: photourl[4] ? photourl[4] : '',
            'sku.code': stock[5],
            'sku.barcode': '',
            'sku.variant1': stock_variants[0],
            'sku.variant2': stock_variants && stock_variants.length > 1 ? stock_variants[1] : '',
            'sku.cost': '',
            'sku.price': price
          }
        })
      })
      json = [].concat(...json)

      dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'zwiz-product.xlsx')
    },
    async closeModal() {
      this.state = 'list'
      await this.$nextTick()
      goTo(0)
    },
    async onChangeProduct() {
      await this.getProducts()
      this.timestamp = moment().format('x')
    },
    onChangeLimit: function (value) {
      this.offset = 0
      this.size = value
      this.pageNumber = 1
      this.getProducts()
      $('html, body').animate({
        scrollTop: 0
      })
    },
    onClickPageinate: function (pageNum) {
      this.pageNumber = pageNum
      $('html, body').animate({
        scrollTop: 0
      })
    },
    async changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.size - this.size
        await this.$nextTick()
        this.getProducts()
      }
    },
    onAddNewProduct: function () {
      var vm = this
      if (
        (vm.$store.getters.getPackage === 'premium' && !vm.isCoachlab) ||
        (vm.$store.getters.getPackage !== 'premium' &&
          vm.productlist &&
          vm.productlist.length < vm.maxProduct) ||
        (vm.isCoachlab && vm.productlist.length < vm.maxProduct)
      ) {
        vm.state = 'add-product'
      }
      this.timestamp = moment().format('x')
    },
    closeEditProduct: async function () {
      await this.getProducts()
      this.$store.dispatch('loading')
      this.state = 'list'
      this.timestamp = moment().format('x')
    },
    onSelectedProduct: function (index, product) {
      this.currentProduct = product
      this.state = 'edit-product'
    },
    onCategoryChange: function () {},
    deleteCategory(categoryid) {
      this.productlist = this.productlist.filter((el) => {
        return el.categoryid != categoryid
      })
      if (this.currentCategory == categoryid) {
        this.setDefaultCategory()
      }
    },
    getCategories: function (callback) {
      let vm = this
      vm.loadingCategory = true
      if (!vm.selectedBot) {
        return
      }
      var data = {
        pageid: vm.selectedBot.pageid
      }
      if (
        vm.selectedBot.useketshop == true &&
        vm.selectedBot.ketshop_api_key &&
        vm.selectedBot.ketshop_api_secret
      ) {
        data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
        data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
      }

      if (vm.isPowerbuyPage && vm.filterBranch) {
        Object.assign(data, { shop_main_pageid: vm.filterBranch.shop_main_pageid })
      }

      if (
        vm.selectedBot.pageid == '106855151601601' ||
        vm.selectedBot.pageid == '102052945584054'
      ) {
        api.getCategoriesKFC(data, function (error, response) {
          if (error) {
            console.error(error)
            return
          }
          vm.categorylist = response.categorylist
          callback()
        })
      } else if (vm.selectedBot.type == 'thailandpostmart') {
        api.getCategoriesThailandPostmart(data, function (error, response) {
          if (error) {
            console.error(error)
            return
          }
          vm.categorylist = response.data
          callback()
        })
      } else {
        api.getCategories(data, function (error, response) {
          if (error) {
            console.error(error)
            return
          }
          if (response && response.categorylist.length !== 0) {
            if (vm.productBy === 'zortOut') {
              response.categorylist = response.categorylist.filter(
                (item) => item.ref_code && item.ref_code.includes('ZORTOUT')
              )
            } else {
              response.categorylist = response.categorylist.filter(
                (item) => !item.ref_code || (item.ref_code && !item.ref_code.includes('ZORTOUT'))
              )
            }
          }
          vm.categorylist = response.categorylist
          callback()
        })
      }
    },

    getProducts: function () {
      const vm = this
      let product = 'zwiz'
      if (vm.productBy == 'zortOut') {
        product = vm.productBy.toLowerCase()
      }
      return new Promise((resolve, reject) => {
        if (!vm.selectedBot) {
          reject()
        }
        let data = {
          pageid: vm.selectedBot.pageid,
          limit: vm.size,
          offset: vm.offset,
          userid: vm.$store.state.userid,
          product_by: product
        }

        if (vm.search && vm.search.trim()) {
          if (vm.isTcpPage) {
            data.product_name = vm.search.trim()
          } else {
            data.search = vm.search.trim()
          }
        }

        if (vm.currentCategory !== 'all') {
          Object.assign(data, { categoryid: vm.currentCategory })
        }

        vm.loadingProduct = true
        if (
          vm.selectedBot.useketshop == true &&
          vm.selectedBot.ketshop_api_key &&
          vm.selectedBot.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
          data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
        }

        if (vm.isPowerbuyPage && vm.filterBranch) {
          Object.assign(data, { shop_main_pageid: vm.filterBranch.shop_main_pageid })
        }

        if (
          vm.selectedBot.pageid == '106855151601601' ||
          vm.selectedBot.pageid == '102052945584054'
        ) {
          data = {
            ...data,
            pageid: vm.selectedBot.pageid,
            limit: vm.size,
            offset: vm.offset
          }

          if (vm.currentCategory !== 'all') {
            Object.assign(data, { categoryid: vm.currentCategory })
          }

          if (vm.currentSubCategory !== 'all') {
            Object.assign(data, {
              categoryid: vm.currentCategory,
              subcategoryid: vm.currentSubCategory
            })
          }

          api.getProductsKFC(data, function (error, response) {
            if (error) {
              console.error(error)
              vm.loadingProduct = false
              resolve()
              return
            }

            if (vm.currentCategory == 'all') {
              vm.totalAllProducts = response.total
            }

            if (vm.currentCategory !== 'all' && vm.currentSubCategory == 'all') {
              vm.totalAllProductsSubcategory = response.total
            }

            vm.total = response.total
            vm.productlist = response.data || []
            vm.loadingProduct = false
            resolve()
          })
        } else if (vm.selectedBot.type == 'thailandpostmart') {
          let data = {
            // slug: 'postemart',
            slug: vm.currentCategory,
            pageid: vm.selectedBot.pageid,
            per_page: vm.size,
            pages: vm.pageNumber,
            search: vm.search
          }

          if (vm.search && vm.search.trim()) data.search = vm.search.trim()

          api.getProductBySlugThailandPostmart(data, function (error, response) {
            if (error) {
              vm.loadingProduct = false
              resolve()
              return
            }
            if (vm.currentCategory == 'all') {
              vm.totalAllProducts = response.total
            }
            vm.total = response.total
            vm.productlist = response.data || []
            vm.loadingProduct = false
            resolve()
          })
        } else {
          api.getProducts(data, function (error, response) {
            if (error) {
              vm.loadingProduct = false
              resolve()
              return
            }
            if (vm.currentCategory == 'all') {
              vm.totalAllProducts = response.total
            }
            vm.total = response.total
            vm.productlist = response.productlist || []
            vm.loadingProduct = false
            resolve()
          })
        }
      })
    },
    addProduct: async function (product) {
      await this.getProducts()
      this.$store.dispatch('loading')
      this.timestamp = moment().format('x')
    },
    onSelectProduct: function (val) {
      this.selectedProduct = this.productlist.find((product) => {
        return product.id == val
      })
    },
    onLoadCategory: function (payload) {},
    onChangeCategory: function () {
      this.pageNumber = 1
      this.offset = 0

      if (this.$store.state.kfcpage.includes(this.selectedBot.pageid)) {
        let categorylist = this.categorylist
        let currentCategory = this.currentCategory
        if (currentCategory !== 'all') {
          let subcategory = undefined

          categorylist.filter((el) => {
            if (el.id === currentCategory) {
              subcategory = el.subcategories
            }
          })

          this.subcategorylist = subcategory
        } else {
          this.subcategorylist = undefined
        }

        this.currentSubCategory = 'all'
      }
      this.getProducts()
    },
    onChangeSubCategory: function () {
      this.pageNumber = 1
      this.offset = 0
      this.getProducts()
    },
    onDeleteProduct: function () {
      this.getProducts()
      this.timestamp = moment().format('x')
    },
    onChangeProductStatus(payload) {
      var index = this.productlist.findIndex((el) => {
        return payload.id == el.id
      })
      this.$set(this.productlist[index], 'status', payload.status)
    },
    setDefaultCategory() {
      if (this.selectedBot.theme == 'nvbb' && this.categorylist.length > 0) {
        this.currentCategory = this.categorylist[0].id
      } else {
        this.currentCategory = 'all'
      }
    },
    handleChangeBranch() {
      const vm = this
      vm.getCategories(function () {
        if (vm.categorylist && vm.categorylist.length > 0) {
          vm.onChangeCategory(vm.categorylist[0])
        }
        vm.getProducts().then(() => {
          vm.loadingCategory = false
        })
      })
    },
    handleSuccessImport() {
      this.getProducts()
    },
    async getStartComponent() {
      this.$store.dispatch('updateBotDetail')
      await this.getCategories()
      if (this.categorylist.length > 0) {
        this.onChangeCategory(this.categorylist[0])
      }
      await this.getProducts()
      this.loadingCategory = false
    },
    selectProductBy(type) {
      const vm = this
      vm.productBy = type
      vm.currentCategory = 'all'
      vm.getStartComponent()
    },
    async checkZortoutImportStatus() {
      try {
        let response = await this.get(`zortout/${this.selectedBot.pageid}/check-sync-product`)
        if (response.data.message == 'SUCCESS') {
          let data = response.data.result[0]
          this.zortoutImport.status = data.status
        }
        return response
      } catch (error) {
        throw error
      }
    },
    async importZortout() {
      this.loadingProduct = true
      this.$store.dispatch('loading')
      try {
        let response = await this.get(`zortout/${this.selectedBot.pageid}/sync-product`)
        if (response.data.message == 'SUCCESS') {
          await this.checkZortoutImportStatus()
          this.zortoutImport.show = true
          this.zortoutImport.loading = true
          this.zortoutImport.status = 'PENDING'
          let count = 0
          this.zortoutImport.interval = setInterval(async () => {
            let response = await this.checkZortoutImportStatus()
            count = count + 1
            if (count === 4) {
              await this.$swal.fire({
                title: this.$t('error'),
                confirmButtonText: this.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
              this.loadingProduct = true
              this.zortoutImport.loading = false
              this.$store.dispatch('loading')
              if (this.zortoutImport.interval) clearInterval(this.zortoutImport.interval)
            }
            if (this.zortoutImport.status == 'SUCCESS') {
              this.loadingProduct = false
              this.zortoutImport.loading = false
              if (this.zortoutImport.interval) clearInterval(this.zortoutImport.interval)
              this.$store.dispatch('loading')

              await this.$swal.fire({
                title: this.$t('success'),
                type: 'success',
                confirmButtonText: this.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
              window.location.reload()
            } else if (this.zortoutImport.status == 'FAILED') {
              this.loadingProduct = false
              this.zortoutImport.loading = false
              if (this.zortoutImport.interval) clearInterval(this.zortoutImport.interval)
              if (response.result.status_message) {
                await this.$swal.fire({
                  title: this.$t('error'),
                  text: response.result.status_message,
                  type: 'error',
                  confirmButtonText: this.$t('Confirm'),
                  showCancelButton: false,
                  reverseButtons: true
                })
                this.$store.dispatch('loading')
              }
            }
          }, 5000)
        }
      } catch (error) {
        this.$store.dispatch('loading')
        if (error.response && error.response.data.message == 'IMPORT_LIMIT_EXCEEDED') {
          await this.$swal.fire({
            title: this.$t('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้งหลังจาก 10 นาที'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        } else {
          await this.$swal.fire({
            title: this.$t('Something went wrong. Please try it again later'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        }
        this.loadingProduct = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ketshop-bg-color {
  background-color: rgb(58, 58, 58);
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Products.vue